import { z } from "zod";
import type { TFunction } from "i18next";

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const buildShelfFormSchema = (t: TFunction<any, any>) =>
  z
    .object({
      name: z.string().min(
        1,
        t(($) => $.analytics.validations["Please enter a shelf name."]),
      ),
      brand_name: z.string().min(
        1,
        t(($) => $.analytics.validations["Please enter a brand name."]),
      ),
      description: z.string(),
      category: z
        .number({ message: t(($) => $.analytics.validations["Please select a category for this shelf."]) })
        .min(
          1,
          t(($) => $.analytics.validations["Please select a category for this shelf."]),
        ),
      keywords: z
        .string()
        .array()
        .min(
          1,
          t(($) => $.analytics.validations["Please select between 1 and 10 keywords for this shelf."]),
        )
        .max(
          10,
          t(($) => $.analytics.validations["Please select between 1 and 10 keywords for this shelf."]),
        ),
    })
    .passthrough();
